import CloseIcon from '@mui/icons-material/Close';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import { Typography, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

import { BLUE0 } from '@/theme/palette';

interface HeaderProps {
  title?: string;
  subtitle?: string;
  onClose?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  title = 'Create Resource',
  subtitle = 'Add a new resource to your organisation.',
  onClose,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 2.5,
        py: 2,
        color: '#fff',
        background: BLUE0,
      }}
    >
      <ViewInArOutlinedIcon sx={{ fontSize: 38 }} />
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 19, fontWeight: 700, lineHeight: 1.25 }}>{title}</Typography>
        <Typography sx={{ fontSize: 12.5, color: 'rgba(255,255,255,0.78)' }}>{subtitle}</Typography>
      </Box>
      {onClose && (
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ color: '#fff', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default Header;
